export const saveStorage = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch (_) {
    void 0; // no-op when localStorage is unavailable
  }
};

export const loadStorage = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (_) {
    return null;
  }
};

export const removeStorage = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (_) {
    void 0; // no-op when localStorage is unavailable
  }
};
